import React, { useContext, useEffect, useState } from 'react';
import { Environment } from 'src/Environment';

import { MerchantProfileContext } from 'src/context/merchant-profile-context';
import HeaderNav from '../header-nav/header-nav';
import { LoaderAnimation } from 'src/components';
import { parseObjectToQueryParamString } from 'src/helpers/functional-helpers';
import TealiumEvents from 'src/helpers/tealium-events';
import './vodapay-deals.scss';

export default function VodapayDeals() {
  const [isInlineFrameLoading, setIsInlineFrameLoading] = useState(true);
  const [isMerchantLoading, setIsMerchantLoading] = useState(true);
  const { merchant } = useContext(MerchantProfileContext);

  const hideLoadingAnimation = () => {
    setIsInlineFrameLoading(false);
  };

  useEffect(() => {
    TealiumEvents.vodapayDealsPageLoad();
  }, []);

  useEffect(() => {
    if (merchant?.companyName) {
      setIsMerchantLoading(false);
    }
  }, [merchant]);

  const getPipefyURL = () => {
    const params = {
      embedded: true,
      merchant_name: merchant?.companyName,
      merchant_id: merchant?.merchantId,
      vodapay_partner_types: 'VodaPay Merchant Partner',
    };

    return `${Environment.current?.pipefyBaseURL}?${parseObjectToQueryParamString(params)}`;
  };

  return (
    <div className="VodapayDeals">
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="VodaPay Deals"
      >
        <h1 className="page-title">VodaPay Deals Request</h1>

        <div className="page-description">
          Drive improved traffic and increase user acquisition to your mini program with deals and
          offers in VodaPay.
        </div>

        {!isMerchantLoading && (
          <iframe
            className={`pipefy-iframe ${isInlineFrameLoading ? 'loading' : ''}`}
            src={getPipefyURL()}
            frameBorder="0"
            onLoad={() => hideLoadingAnimation()}
          />
        )}

        {(isInlineFrameLoading || isMerchantLoading) && (
          <div className="has-text-centered loader-container">
            <LoaderAnimation />
          </div>
        )}
      </HeaderNav>
    </div>
  );
}
